module.exports = __webpack_public_path__ + "fonts/Inter-200-greek14.3a3cf1a.woff2";